import { useTranslation } from 'react-i18next';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { ChangePasswordForm } from './ChangePasswordForm';
import styles from './LoginPage.module.css';

/**
 * Seite für den erzwungenen Passwortwechsel (nach Admin-Reset oder Altpasswort). Sobald das Profil
 * keinen Wechsel mehr verlangt, geht es zur Startseite.
 */
export function ChangePasswordPage() {
  const { t } = useTranslation();
  const { user } = useAuth();
  if (user && !user.mustChangePassword) return <Navigate to="/" replace />;
  return (
    <section className={styles.card}>
      <h1>{t('password.forcedTitle')}</h1>
      <p>{t('password.forcedIntro')}</p>
      <ChangePasswordForm />
    </section>
  );
}
